import { sendGTMEvent } from "@next/third-parties/google";
import { startCase } from "lodash";
import { Context, createContext } from "react";
import { ShopCartTransaction } from "../cart/cart-types";
import { ShopBrowsingData, ShopProductPageData } from "../shop/shop-types";
import { GTMEventData, GTMItem, GTMItemContext, GTMItemListID } from "./analytics-types";

export class GTM {
    static ItemContext: Context<GTMItemContext>;
    static {
        GTM.ItemContext = createContext({
            item_list_id: "unknown" as GTMItemListID,
            item_list_name: "Unknown",
            items: [] as GTMItem[]
        });
    }

    static sendEvent(data: GTMEventData): void {
        sendGTMEvent(data);
    }

    static itemsFromBrowse(products: ShopBrowsingData[] | ShopProductPageData[]): GTMItem[] {
        return products.map((product, index) => ({
            item_id: product.productID.toString(),
            item_name: product.name,
            affiliation: product.supplierName || "",
            index,
            item_brand: product.brandFamily,
            item_category: product.categoryName,
            item_category2: product.productTypeName,
            price: product.price ? parseFloat(product.price.unitPrice.toString()) : undefined,
            discount: product.price ? parseFloat(product.price.unitDiscount.toString()) : undefined
        }));
    }

    static itemsFromCart(transactions: ShopCartTransaction[]): GTMItem[] {
        return transactions.map((transaction) => {
            const item_list_id = transaction.addedFrom || "unknown";
            const item_list_name = startCase(item_list_id);
            return {
                item_id: transaction.productID.toString(),
                item_name: transaction.productName,
                affiliation: transaction.supplierName,
                coupon: transaction.promotionName,
                item_brand: transaction.brandFamily,
                item_category: transaction.menuCategory,
                item_category2: transaction.productType,
                item_list_id,
                item_list_name,
                quantity: transaction.numUnits,
                price: parseFloat(transaction.unitPrice.toString()),
                discount: parseFloat(transaction.discount.toString())
            };
        });
    }
}
